import styled from "styled-components"

export const StyledUserApplicationItem = styled.div`
	background: #fff;
	border: 1px solid #D9D9D9;
	padding-left: 24px;
	padding-right: 24px;
	
	p{
		margin-bottom: 0;
	}
	
	.number, .title{
		font-size: 20px;
		line-height: 32px;
	}

  .status, .date{
    font-size: 16px;
    line-height: 24px;
  }
	
	.title{
		padding-left: 26px;
	}
	
	.status{
		color: #D68945;
		padding-right: 16px;
	}
	
	.date{
		color: #838387;
	}
	
	.moreButton, .openApplication{
		border-radius: 4px;
	}
	
	.moreButton{
		padding: 4px;
		margin-left: 16px;
	}
	
	.openApplication{
		border-color: #51258F;
		color: #2C8742;
		font-size: 18px;
		line-height: 24px;
		font-weight: 500;
		padding: 8px 12px;
	}
`